import type { App } from '../app';
import type { CallLog, CallLogEntry } from '../calllog/calllog';
import type { Store } from '../state/store';
import { formatDuration, h } from './dom';

const LABEL: Record<CallLogEntry['result'], string> = {
  answered: '',
  missed: 'Verpasst',
  rejected: 'Abgelehnt',
  failed: 'Nicht erreicht',
};

export function renderCallLog(root: HTMLElement, app: App, store: Store, callLog: CallLog): void {
  const render = () => {
    root.replaceChildren();
    const entries = callLog.list();
    if (entries.length === 0) {
      root.append(h('p', { class: 'muted' }, 'Noch keine Anrufe auf diesem Gerät.'));
      return;
    }
    const list = h('ul', { class: 'calllog' });
    for (const e of entries) {
      const time = new Date(e.startedAt).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' });
      const detail = [e.direction === 'in' ? 'Eingehend' : 'Ausgehend', time, LABEL[e.result], e.durationSec ? formatDuration(e.durationSec) : '']
        .filter(Boolean)
        .join(' · ');
      const callback = h('button', { type: 'button', 'data-action': 'callback', 'aria-label': `${e.number} anrufen` }, 'Anrufen');
      callback.addEventListener('click', () => app.dial(e.number));
      list.append(
        h(
          'li',
          { 'data-result': e.result },
          h('div', {}, h('div', { class: 'who' }, e.displayName ?? e.number), h('div', { class: 'muted' }, detail)),
          callback,
        ),
      );
    }
    root.append(list);
  };
  store.subscribe((s) => {
    // neu zeichnen, wenn ein Anruf endet (missedCount/Call wechseln)
    if (s.call === null) render();
  });
  render();
}
